/* eslint-disable radix */
/* eslint-disable camelcase */
/* eslint-disable no-lonely-if */
/* eslint-disable no-bitwise */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-undef */
import { sha256 } from 'js-sha256';
// import { stringify } from "querystring";

export function debounce(fn, delay) {
  let timer = null;

  return function () {
    let args = arguments;
    let context = this;

    if (timer) {
      clearTimeout(timer);

      timer = setTimeout(() => {
        fn.apply(context, args);
      }, delay);
    } else {
      timer = setTimeout(() => {
        fn.apply(context, args);
      }, delay);
    }
  }
}
export function throttle(fn, delay) {
  let timer = null,
    remaining = 0,
    previous = new Date();

  return function () {
    let now = new Date(),
      remaining = now - previous,
      args = arguments,
      context = this;

    if (remaining >= delay) {
      if (timer) {
        clearTimeout(timer);
      }

      fn.apply(context, args);
      previous = now;
    } else if (!timer) {
      timer = setTimeout(() => {
        fn.apply(context, args);
        previous = new Date();
      }, delay - remaining);
    }
  };
}
export function getChatId(userId, targetId) {
  return [userId, targetId].sort().join('_')
}

export function getUrlParamProps(props, name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');//构造一个含有目标参数的正则表达式对象
  let search = props.location.href.split('?')[1]
  let r = search && search.match(reg);//匹配目标参数
  if (r != null) return decodeURI(r[2]); return null;//返回参数值
}

export function getUrlParam(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');//构造一个含有目标参数的正则表达式对象
  let search = window.location.href.split('?')[1]
  let r = search && search.match(reg);//匹配目标参数
  if (r != null) return decodeURI(r[2]); return null;//返回参数值
}

export function getUuid() {
  function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  }
  return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
}

export function getSign(params) {
  // console.log(params);
  function rechangeValue(str) {
    let props = params.headers;
    return props[str] ? `${str}=${props[str]}` : `${str}`;
  }

  function joint(data) {
    if (!data) return false;
    // console.log(data['user_ids']);

    let total = '',
      count = 0,
      all = Object.keys(data).length;
    for (let key in data) {
      count++;
      if (data[key]) {
        // console.log(count, all);
        // console.log(data[key], JSON.stringify(data[key]), typeof (data[key]))
        if (all > count) {
          // total += `${key}=${JSON.stringify(data[key])}&`;
          if (typeof (data[key]) === 'object') {
            total += `${key}=${JSON.stringify(data[key])}&`;
          } else {
            total += `${key}=${data[key]}&`;
          }
        } else {
          // total += `${key}=${JSON.stringify(data[key])}`;
          if (typeof (data[key]) === 'object') {
            total += `${key}=${JSON.stringify(data[key])}`;
          } else {
            total += `${key}=${data[key]}`;
          }
        }
      } else if (all > count) {
        total += `${key}&`;
      } else {
        total += `${key}`;
      }
    }
    return total;
  }

  let querys_data = params.params,
    bodys_data = params.data;

  let action = rechangeValue('action'),
    x_k7_version = rechangeValue('x-k7-version'),
    x_k7_business_headers = rechangeValue('x-k7-business-headers'),
    x_k7_appid = rechangeValue('x-k7-appid'),
    x_k7_business_appid = rechangeValue('x-k7-business-appid'),
    x_k7_userid = rechangeValue('x-k7-userid'),
    x_k7_sessionkey = rechangeValue('x-k7-sessionkey'),
    x_k7_timestamp = rechangeValue('x-k7-timestamp'),
    x_k7_nonce = rechangeValue('x-k7-nonce'),
    path = `${window.location.protocol}${params.baseURL}${params.url}`,
    querys = joint(querys_data),
    bodys = joint(bodys_data);

  const sign = `${action}&${x_k7_version}&${x_k7_business_headers}
  &${x_k7_appid}&${x_k7_business_appid}&${x_k7_userid}&${x_k7_sessionkey}
  &${x_k7_timestamp}&${x_k7_nonce}\n${path}${querys ? '?' + querys : ''}${bodys ? '\n' + bodys : ''}`

  return (sha256.hmac('166c790489ee445f99217cdc8a0a3edb', sign)).toUpperCase();
}

export function datetime_to_unix(datetime) {
  if (datetime) {
    let tmp_datetime = datetime.replace(/:/g, '-');
    tmp_datetime = tmp_datetime.replace(/ /g, '-');
    let arr = tmp_datetime.split('-');
    let now = new Date(Date.UTC(arr[0], arr[1] - 1, arr[2], arr[3] - 8, arr[4], arr[5]));
    return parseInt(now.getTime() / 1000);
  }
}

export const getUrlQuery = () => {
  let url = decodeURI(window.location.search); //获取url中"?"符后的字串
  // eslint-disable-next-line no-new-object
  let theRequest = new Object();
  if (url.indexOf('?') != -1) {
    let str = url.substr(1);
    let strs = str.split('&');
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
    }
  }
  return theRequest;
}

// cancel
export const closeWindow = () => {
  window.external && window.external.closeWindow && window.external.closeWindow()
}

// ok
export const endDialog = () => {
  window.external && window.external.endDialog && window.external.endDialog()
}

export const openBindMobile = () => {
  const HREF = encodeURIComponent(`https://www.inapp-desktop.cn/#/bindMobile?Key=${getUrlParam('Key')}&Uid=${getUrlParam('Uid')}`)
  const BIND_MOBILE_URL = `k7game://openwebdlg?flag=1&url=${HREF}`
  return BIND_MOBILE_URL
}
